<p-fileUpload name="file-upload[]"
  (onUpload)="onUpload($event)"
  (onSelect)="onSelect($event)"
  (uploadHandler)="onUpload($event)"
  [multiple]="multipleFiles"
  [showCancelButton]="false"
  [auto]="false"
  [accept]="allowedFiles === '*' ? '' : allowedFiles"
  [chooseLabel]="chooseLabel | i18next: {count: maxFileLength}"
  [uploadLabel]="uploadLabel | i18next"
  [chooseIcon]="chooseIcon"
  [styleClass]="styleClass"
  [url]="uploadUrl"
  [showUploadButton]="showUploadButton"
  [customUpload]="customUpload">
  <ng-template pTemplate="toolbar">
    @if (maxFileLength > 1) {
      <div class="mt-2">{{ "file_uploader_file_upload_hint_plural" | i18next: { count: maxFileLength, maxSize: (maxFileSize | formatByteSize) } }}</div>
    } @else {
      <div class="mt-2">{{ "file_uploader_file_upload_hint" | i18next: { count: maxFileLength, maxSize: (maxFileSize | formatByteSize) } }}</div>
    }
    @if (allowedFiles !== '*') {
      <div>{{ "file_uploader_file_upload_allowed_type_hint" | i18next: { allowedFileTypes: displayAllowedFileTypesTranslation } }}</div>
    }
  </ng-template>
  <ng-template pTemplate="file"></ng-template>
  <ng-template pTemplate="content">
    @if (attachedFiles.length <= 0) {
      <div class="red font-weight-bold">{{ 'file_uploader_drag_select' | i18next }}</div>
    }
    @if (attachedFiles.length > 0) {
      <div>
        <div class="mt-3 font-weight-bold">
          <span class="pi pi-upload p-button-icon p-button-icon-left"></span>
          {{ "file_uploader_attached_files_headline" | i18next }}
        </div>
        @for (f of attachedFiles; track f; let i = $index) {
          <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center">
            @if (f.file && f.file.objectURL && isImage(f.file)) {
              <div><img [src]="f.file.objectURL" width="50px" /></div>
            }
            @if (f.file && !isImage(f.file)) {
              <div class="text-right">
                <i class="fas fa-paperclip"></i>
              </div>
            }
            @if (f.file) {
              <div class="mr-2">{{f.file.name}}</div>
            }
            @if (f.file) {
              <div>{{ f.file.size | formatByteSize:{iecCalc: false} }}</div>
            }
            @if (f.file) {
              <div class="d-flex align-items-center">
                @if (!isUploadDone(i) && getFileProgress(i) > 0) {
                  <span>{{ getFileProgress(i) }}%</span>
                }
                @if (!isUploadDone(i)) {
                  <button type="button" icon="pi pi-times" pButton (click)="removeFile(i)"></button>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-template>
</p-fileUpload>
